// Accounting › Fixed assets — the words shared by its three tabs (batch 9 R4). Each tab keeps its own
// package (facat · fareg · fadep) so the three could be built in parallel without touching one file.
// Rules (as every mt package): no _plural keys; numbers as {{n}}; no empty value in any language.
export const en: Record<string, string> = {
  aw_fa_tabs_label: 'Fixed assets',
  aw_fa_tab_categories: 'Asset Categories',
  aw_fa_tab_register: 'Asset Register',
  aw_fa_tab_depreciation: 'Depreciation',
  aw_fa_status_in_use: 'In use',
  aw_fa_status_not_yet_available: 'Not yet available for use',
  aw_fa_status_idle: 'Idle',
  aw_fa_status_fully_depreciated: 'Fully depreciated',
  aw_fa_status_disposed: 'Disposed',
  aw_fa_status_written_off: 'Written off',
};
export const zh: Record<string, string> = {
  aw_fa_tabs_label: '固定资产',
  aw_fa_tab_categories: '资产类别',
  aw_fa_tab_register: '资产登记簿',
  aw_fa_tab_depreciation: '折旧',
  aw_fa_status_in_use: '使用中',
  aw_fa_status_not_yet_available: '尚未可供使用',
  aw_fa_status_idle: '闲置',
  aw_fa_status_fully_depreciated: '已提足折旧',
  aw_fa_status_disposed: '已处置',
  aw_fa_status_written_off: '已核销',
};
export const th: Record<string, string> = {
  aw_fa_tabs_label: 'สินทรัพย์ถาวร',
  aw_fa_tab_categories: 'หมวดสินทรัพย์',
  aw_fa_tab_register: 'ทะเบียนสินทรัพย์',
  aw_fa_tab_depreciation: 'ค่าเสื่อมราคา',
  aw_fa_status_in_use: 'ใช้งานอยู่',
  aw_fa_status_not_yet_available: 'ยังไม่พร้อมใช้งาน',
  aw_fa_status_idle: 'ไม่ได้ใช้งาน',
  aw_fa_status_fully_depreciated: 'คิดค่าเสื่อมครบแล้ว',
  aw_fa_status_disposed: 'จำหน่ายแล้ว',
  aw_fa_status_written_off: 'ตัดจำหน่ายแล้ว',
};
